import AnnouncementsPage from "./AnnoucementsPage";

const module = {
  routeProps: {
    path: "Announcements",
    component: AnnouncementsPage,
  },

  name: "Announcements",
  label: "Announcements",
  title: "Announcements",
  showOnMenu: true,
};
export default module;
